import { VideoCardData } from '@tenants/types/tenant';
import { joinExpCaPaths, joinExpUsPaths, Namespaces } from 'types/locales';

export function createVideoCardsData(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA): readonly VideoCardData[] {
  
  const videoCard1: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card1`;
  const videoCard2: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card2`;
  const videoCard3: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card3`;
  const videoCard4: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card4`;
  const videoCard5: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card5`;
  const videoCard6: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card6`;
  const videoCard7: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card7`;
  const videoCard8: joinExpCaPaths | joinExpUsPaths = `${namespace}:videoCards.card8`;

  const videoCardsData: readonly VideoCardData[] = [
    {
      videoId: 'hv5oA6q_phM',
      bottomText: videoCard1,
    },
    {
      videoId: 'AA76L8hw7oU',
      bottomText: videoCard2,
    },
    {
      videoId: 'pGH14z9XpRc',
      bottomText: videoCard3,
    },
    {
      videoId: 'vK24zkG4C0k',
      bottomText: videoCard4,
    },
    {
      videoId: 'VdulH47weDY',
      bottomText: videoCard5,
    },
    {
      videoId: 'H_DP7Pmme0s',
      bottomText: videoCard6,
    },
    {
      videoId: 'xcx9cySzqFY',
      bottomText: videoCard7,
    },
    {
      videoId: 'x0dZCrsGBAw',
      bottomText: videoCard8,
    },
  ] as const;

  return videoCardsData;
}